import PaymentSupplyChain from "./PaymentSupplyChain";
export default PaymentSupplyChain;
